export default "__VITE_PUBLIC_ASSET__125090aa__"